import { onError } from "@apollo/client/link/error";

// GraphQL でエラー時に必ず実行する処理
// 呼び出し側でのハンドリングも必要
export const createErrorLink = () =>
  onError(({ response, graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      graphQLErrors.forEach((graphQLError) => {
        const { extensions, message, path, ...rest } = graphQLError;

        // 未ログインで query を叩くのは正常系なので無視
        // TODO: error code を設けてそれで判断する
        if (message !== "ログインが必要です。") {
          // TODO: warning として Sentry でロギング
          console.warn(message, { path, extensions, ...rest });
        }

        // エラーメッセージが英文のみの場合は ActiveRecord 等生のエラーが返ってきているか、
        // 古い GraphQL schema が使われていると判断し、デフォルトのメッセージで埋める
        const isUserFriendlyMessage =
          message.length > 0 && !message.match(/^[a-zA-Z0-9!-/:-@¥[-`{-~\s]+$/);

        if (!isUserFriendlyMessage) {
          graphQLError.message = "問題が発生しました。画面を再読み込みしてください。";
          response?.errors
            ?.filter((e) => e.message === message)
            ?.forEach((e) => (e.message = "問題が発生しました。時間を置いて再度お試しください。"));
        }
      });
    }

    if (!!networkError) {
      const message = networkError.message;
      const isUserFriendlyMessage =
        message.length > 0 && !message.match(/^[a-zA-Z0-9!-/:-@¥[-`{-~\s]+$/);

      if (!isUserFriendlyMessage) {
        if ("statusCode" in networkError) {
          // ServerParseError | ServerError のとき
          networkError.message = "問題が発生しました。時間を置いて再度お試しください。";
        } else {
          networkError.message = "インターネットの接続状況をご確認のうえ、再度お試しください。";
        }
      }
    }
  });
